import React from 'react'
import {
    Box,
    Checkbox,
    FormControlLabel,
    FormGroup,
    Typography,
    makeStyles,
    Theme,
} from '@material-ui/core'

import { StepEditPanelProps } from '../pipelineBuilder.types'
import { ProspectsStepConfig } from '../stepConfig.types'
import { getStepConfig } from '../stepConfigUtils'

const useStyles = makeStyles((theme: Theme) => ({
    section: {
        marginBottom: theme.spacing(2),
    },
    sectionTitle: {
        fontWeight: 600,
        fontSize: '0.8125rem',
        marginBottom: theme.spacing(1),
        color: theme.palette.text.secondary,
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
    },
    helper: {
        fontSize: '0.8125rem',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(1.5),
        lineHeight: 1.5,
    },
}))

export const ProspectsStepPanel: React.FC<StepEditPanelProps> = ({
    step,
    readOnly = false,
    onChange,
}) => {
    const classes = useStyles()
    const config = getStepConfig(step, 'prospects')

    const updateConfig = (patch: Partial<ProspectsStepConfig>) => {
        onChange({
            config: { ...config, ...patch },
        })
    }

    return (
        <Box>
            <Box className={classes.section}>
                <Typography className={classes.sectionTitle}>
                    Campaigns
                </Typography>
                <Typography className={classes.helper}>
                    Automatically enroll pool prospects into your
                    property&apos;s primary campaigns when contact info is
                    available.
                </Typography>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={config.auto_enroll_email_campaign}
                                onChange={(_, checked) =>
                                    updateConfig({
                                        auto_enroll_email_campaign: checked,
                                    })
                                }
                                disabled={readOnly}
                                color="primary"
                            />
                        }
                        label="Auto-enroll all prospects with email in email primary campaign"
                    />
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={config.auto_enroll_phone_campaign}
                                onChange={(_, checked) =>
                                    updateConfig({
                                        auto_enroll_phone_campaign: checked,
                                    })
                                }
                                disabled={readOnly}
                                color="primary"
                            />
                        }
                        label="Auto-enroll all prospects with phone in phone primary campaign"
                    />
                </FormGroup>
            </Box>
        </Box>
    )
}
